import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { ModalModule } from '../modal/modal.module';
import { AvailableOptionModalComponent } from './available-option-modal.component';

@NgModule({
  declarations: [AvailableOptionModalComponent],
  imports: [CommonModule, SharedModule, ModalModule],
  exports: [AvailableOptionModalComponent]
})
export class AvailableActionModalModule {}
